// Determine the API base URL based on environment
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000'
  }
  return '' // Use relative URL for production
}

const API_BASE_URL = getBaseURL()

export async function fetchSeats(showId, scheduleId, sessionUUID) {
  const response = await fetch(`${API_BASE_URL}/api/seats/${showId}/${scheduleId}`, {
    headers: sessionUUID ? { 'X-Session-UUID': sessionUUID } : {}
  })

  await handleError(response)

  const data = await response.json()
  return data.data
}

export async function fetchAdminSeats(showId, scheduleId) {
  const response = await fetch(`${API_BASE_URL}/api/admin/seats/${showId}/${scheduleId}`, {
    credentials: 'include'
  })

  await handleError(response)

  const data = await response.json()
  return data.data
}

export async function fetchImages() {
  const response = await fetch(`${API_BASE_URL}/api/images`)
  await handleError(response)

  const data = await response.json()
  return data.records.map((record) => ({
    id: record.id,
    title: record.fields["Titre de l'image"] || '',
    description: record.fields.Description || '',
    img: record.fields.Image && record.fields.Image[0] ? record.fields.Image[0].url : '',
    date: record.fields["Date d'ajout"] || '',
    rows: record.fields['Double Image'] ? 2 : 1,
    cols: record.fields['Double Image'] ? 2 : 1
  }))
}

async function handleError(response) {
  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`)
    error.status = response.status
    error.body = response.body ? await response.json() : null
    throw error
  }
}

export async function reserveSeats(seatIds, showId, scheduleId, sessionUUID) {
  const response = await fetch(`${API_BASE_URL}/api/seats/reserve`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      seatIds,
      show_id: showId,
      schedule_id: scheduleId,
      sessionUUID: sessionUUID
    })
  })
  await handleError(response)
  return await response.json()
}

// admin
export async function updateSeatStatus({ seat_id, status, show_id, schedule_id, admin_data, previousStatus }) {
  const response = await fetch(`${API_BASE_URL}/api/seats/update-status`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      seat_id,
      status,
      show_id,
      schedule_id,
      admin_data,
      previousStatus
    })
  })

  await handleError(response)

  return await response.json()
}

export async function getSeatDetails({ seat_id, show_id, schedule_id }) {
  const response = await fetch(`${API_BASE_URL}/api/seats/details`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      seat_id,
      show_id,
      schedule_id
    })
  })

  await handleError(response)

  return await response.json()
}

export async function getSeatAuditHistory({ seat_id, show_id, schedule_id }) {
  const response = await fetch(`${API_BASE_URL}/api/seats/audit`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      seat_id,
      show_id,
      schedule_id
    })
  })
  await handleError(response)
  return response.json()
}

export async function adminLogin(userName, password) {
  const response = await fetch(`${API_BASE_URL}/api/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      username: `${userName}`,
      password
    })
  })
  await handleError(response)
  return response
}

export async function adminLogout() {
  await fetch(`${API_BASE_URL}/api/logout`, {
    method: 'POST',
    credentials: 'include'
  })
}

export async function fetchShows() {
  const response = await fetch(`${API_BASE_URL}/api/shows`)

  await handleError(response)
  return response.json()
}
export async function archivePrice(priceId) {
  const response = await fetch(`${API_BASE_URL}/api/stripe/price/archive`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ price_id: priceId })
  })
  await handleError(response)
  return response.json()
}

export async function unarchivePrice(priceId) {
  const response = await fetch(`${API_BASE_URL}/api/stripe/price/unarchive`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ price_id: priceId })
  })
  await handleError(response)
  return response.json()
}

export async function createPrice({ product_id, amount, nickname }) {
  const response = await fetch(`${API_BASE_URL}/api/stripe/price/create`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ product_id, amount, nickname })
  })
  await handleError(response)
  return response.json()
}

export async function getBookingDetails(bookingId) {
  const response = await fetch(`${API_BASE_URL}/api/stripe/booking-details`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ booking_id: bookingId })
  })

  await handleError(response)

  return await response.json()
}

export async function checkAuth() {
  const response = await fetch(`${API_BASE_URL}/api/admin/check`, { credentials: 'include' })
  await handleError(response)
  return response.json()
}

export async function uploadImage(file, title, description, doubleImage) {
  var formData = new FormData()
  formData.append('file', file)
  formData.append('title', title)
  formData.append('description', description)
  formData.append('doubleImage', doubleImage ? 'true' : 'false')

  var response = await fetch(`${API_BASE_URL}/api/images`, {
    method: 'POST',
    credentials: 'include',
    body: formData
  })
  await handleError(response)
  return await response.json()
}

export async function updateImage(id, title, description, doubleImage) {
  var response = await fetch(`${API_BASE_URL}/api/images/${id}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      title: title,
      description: description,
      doubleImage: doubleImage
    })
  })
  await handleError(response)
  return await response.json()
}

export async function deleteImage(id) {
  var response = await fetch(`${API_BASE_URL}/api/images/${id}`, {
    method: 'DELETE',
    credentials: 'include'
  })
  await handleError(response)
  return await response.json()
}

// Schedule settings - admin (write to cds_schedules table)
export async function updateScheduleSetting({ show_id, schedule_id, key, value }) {
  const response = await fetch(`${API_BASE_URL}/api/schedule-settings/update?show_id=${show_id}&schedule_id=${schedule_id}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ schedule_id, key, value })
  })
  await handleError(response)
  return response.json()
}

// Schedule creation - admin (create new schedule + all seats)
export async function createSchedule({ show_id, schedule_id, date, time }) {
  const response = await fetch(`${API_BASE_URL}/api/schedules/create`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ show_id, schedule_id, date, time })
  })
  await handleError(response)
  return response.json()
}

// Schedule deletion - admin (delete schedule + its seats)
export async function deleteSchedule(show_id, schedule_id) {
  const response = await fetch(`${API_BASE_URL}/api/schedules/${show_id}/${schedule_id}`, {
    method: 'DELETE',
    credentials: 'include'
  })
  await handleError(response)
  return response.json()
}
